import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';

export function usersSearchApi(path: string) {
  return {
    path,
    GET: (query: string) =>
      api.get<JsonApiResponse>(path, {
        params: {
          query,
        },
      }),
  };
}
